import { AxiosError } from "axios"
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"

export interface Usuario extends Model
{
    NombreUsuario: string,
    Nombre:string,
    Apellido:string,
    Conectado?:boolean
    Contrasena:string
    Role:{
        Id:number,
        nombre:string,
        permisos:string[]
    }
    JuzgadoConfiguracionId?: number
    IdentificadoresEquipoJuzgado?: string
    ConveniosPagoConfiguracionId?:number
    Deshabilitado: boolean
}

export interface UsuarioSave extends Omit<Partial<Usuario>, 'Role'>
{
    Rol?:number
}

export interface LoginData {
    NombreUsuario:string
    Contrasena:string
}

export interface LoginResponse
{
    token:string
    validoHasta:string
    nombre:string
    apellido:string
    id:number
    rol:{
        id:number
        nombre:string
        permisos:string[]
    }
    nombreUsuario:string
    identificadoresEquipoJuzgado?: number[]
    juzgadoConfiguracionId: number
}

export interface usrConfig
{
    nombre:string
    apellido:string
    id:number
    rol:{
        id:number
        nombre:string
        permisos:string[]
    }
    nombreUsuario:string
    identificadoresEquipoJuzgado?: number[]
    JuzgadoConfiguracionId?: number
    conveniosDescuentos:{
        id:number
        descuento:number[]
    }
}

export default ()  => {
    const api = useApi({module:"Usuario"});
    
    return {
        list:(query:Query)=>api.list!<Usuario>(query),
        save:(data:UsuarioSave)=>api.save!<UsuarioSave,Usuario>(data,true),
        delete:(id:number)=>api.delete(id),
        login:async (data:LoginData):Promise<ActionResult<LoginResponse>> =>{
           
            try {
                const response = await api.axiosInstance.post<LoginResponse>('/Usuario/Login',data);
                return {
                    data: {value:response.data},
                };
            } catch (error : any | AxiosError) {
    
                return {
                    error
                };
            }
        },
        config:async ():Promise<ActionResult<usrConfig>> =>{
           
            try {
                let data = JSON.parse(localStorage.getItem("_user") ?? "")
                const response = await api.axiosInstance.post<usrConfig>('/Usuario/Config', data.Id);
                return {
                    data: {value:response.data},
                };
            } catch (error : any | AxiosError) {
    
                return {
                    error
                };
            }
        }
    };
}
